"use strict";
import VueGallery from 'vue-gallery';
import axios from "axios"

let bus = new Vue();

Vue.component("bsn-lightbox", {
    data() {
        return {
            index: null,
            images: [],
            galleryOpen: false,
        }
    },
    components: {
        'gallery': VueGallery
    },
    methods: {
        triggerGallery: function () {
            this.galleryOpen = !this.galleryOpen;
            bus.$emit("triggerGallery");
        },
        buildGallery: function () {
            let galleryImages = document.querySelectorAll(".gallery__picture img");


            let imgSrcs = [];

            for (let i = 0; i < galleryImages.length; i++) {
                if (galleryImages[i].dataset.original) {
                    imgSrcs[i] = galleryImages[i].dataset.original;
                }
            }

            this.images = imgSrcs;
        },
        addImagesToGallery: function (galleryImages) {
            for (let i = 0; i < galleryImages.length; i++) {
                this.images.push(galleryImages[i].original);
            }
        },
        switchIndex: function (index) {
            this.index = index;
        }
    },
    mounted: function () {
        this.buildGallery();
        bus.$on("imagesLoaded", this.addImagesToGallery);
        bus.$on("switchIndex", this.switchIndex);
    }
});


Vue.component("bsn-gallery", {
    props: ["getUrl"],
    data() {
        return {
            images: null,
            open: false,
        }
    },
    template: `
    <div v-if="open" class="gallery gallery--small">
            <div class="gallery__picture gallery__picture--small" v-for="image in images">
                <div class="gallery__buttons">
                    <a class="gallery__button" @click="openLightbox(image.key)"><i class="fa fa-search"></i></a>
                </div>
                <img :src="image.thumbnail" alt="" :data-original="image.original">
            </div>
            <div class="gallery__spacer"></div>
    </div>
    `,
    methods: {
        triggerGallery: function () {
            this.open = !this.open;

            if (this.open && !this.images) {

                axios.get(this.getUrl)
                    .then((response) => {
                        this.images = response.data;
                        bus.$emit("imagesLoaded", response.data);
                    })
                    .catch((error) => {
                        console.error(error);
                    })
            }
        },
        openLightbox: function (key) {
            bus.$emit("switchIndex", key);
        }
    },
    mounted: function () {
        bus.$on("triggerGallery", this.triggerGallery);
    }
});


// WEBPACK FOOTER //
// ./frontend/js/lightbox.js